import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button, Col, Input, Label, Media, Pagination, PaginationItem, PaginationLink, PopoverBody, Row, Spinner, UncontrolledPopover, Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap';
import { DateTimePicker } from 'react-widgets';
import { size } from 'lodash';
import { getBalanceAndHistoryCheck, getRoomLog, getRoomOptions } from '../../../actions/admin';
import { CANT_JOIN_ROOM_REASON, ENTERKEY, FORMAT_DATE_TYPE, SPEED_TYPE } from '../../../constants/constants';
import draugiemImg from '../../../images/icons/draugiem.svg';
import facebookImg from '../../../images/icons/facebook.svg';
import inboxImg from '../../../images/icons/inbox.svg';
import DateFormat from '../UI/DateFormat';

import RoomLogs from './RoomLogs';

const BalanceAndHistoryCheck = ({ offset }) => {
  const dispatch = useDispatch();
  const [userId, setUserId] = useState('');
  const [startDate, setStartDate] = useState(new Date(Date.now() - 24 * 60 * 60 * 1000));
  const [endDate, setEndDate] = useState(new Date());
  const [currentPage, setCurrentPage] = useState(0);
  const [isReset, setIsReset] = useState(false);
  const [openModal, setOpenModal] = useState(null);
  const [openModalRoom, setOpenModalRoom] = useState(null);
  const [openModalRoomId, setOpenModalRoomId] = useState(null);

  const pageSize = 50;


  const balanceAndHistoryCheck = useSelector(state => state.admin.balanceAndHistoryCheck || {});
  const balanceAndHistoryCheckCount = useSelector(state => state.admin.balanceAndHistoryCheckCount || 0);

  const selectedRoomData = useSelector(state => state.admin.roomData || {});
  const selectedroomOptions = useSelector(state => state.admin.roomOptions || {});

  useEffect(() => {
    dispatch(getBalanceAndHistoryCheck(startDate, endDate, null));
  }, []);

  const filterFunc = () => {
    if (Date.parse(startDate) > Date.parse(endDate)) return;

    setCurrentPage(0);
    dispatch(getBalanceAndHistoryCheck(startDate, endDate, userId));
  };

  const resetFilters = () => {
    const newStartDate = new Date(Date.now() - 24 * 60 * 60 * 1000);
    const newEndDate = new Date();
    setUserId('');
    setStartDate(newStartDate);
    setEndDate(newEndDate);
    dispatch(getBalanceAndHistoryCheck(newStartDate, newEndDate, ''));
    setIsReset(false);
  };

  const handleKeyPress = (target) => {
    if (target.charCode === ENTERKEY) {
      filterFunc();
    }
  };

  const handleChange = (event) => {
    setUserId(event.target.value);
    if (event.target.value !== '') {
      setIsReset(true);
    }
  };

  const changeStartDate = (date) => {
    if (date === startDate) return;
    setStartDate(date);
    setIsReset(true);
  };

  const changeEndDate = (date) => {
    if (date === endDate) return;
    setEndDate(date);
    setIsReset(true);
  };

  const handleClick = (e, index) => {
    e.preventDefault();

    setCurrentPage(index);
  };

  const openRoomLogsModal = (roomId) => {
    console.log('openModal', roomId);

    if (roomId) {
      dispatch(getRoomLog(roomId));
      dispatch(getRoomOptions(roomId));

      setOpenModal(true);
      setOpenModalRoomId(roomId);
    }
  }

  const closeModal = () => {
    console.log('closeModal');

    setOpenModal(null);
    setOpenModalRoomId(null);
  }

  const openPage = (uid) => {
    const { host } = window.location;
    window.open(`https://${host}/admin/users?searchUid=${uid}`, '_blank', 'noopener,noreferrer');
  }

  if (!balanceAndHistoryCheck || (balanceAndHistoryCheck && balanceAndHistoryCheck.loading)) {
    return (
      <Spinner type="grow" color="warning" style={{ width: '2rem', height: '2rem' }} />
    );
  }

  const pagesCount = Math.ceil(size(balanceAndHistoryCheck) / pageSize);
  console.log(balanceAndHistoryCheck, 'check cant join room');

  return (
    <Fragment>
      <UncontrolledPopover popperClassName="popover" placement="right" trigger="focus" target="admin-help-button-events-banner">
        <PopoverBody className="popover-body">
          This shows the errors found by calculating all old and new balance and points values ​​from the game/room logs and then comparing them to the player's actual balance and points after the room ends.
        </PopoverBody>
      </UncontrolledPopover>
      <div className="admin-page-content">
        <Row>
          <Col sm="4">
            <h2>
              Balance & History Check
              <Button className="admin-help-button" id="admin-help-button-events-banner">
                ?
              </Button>
            </h2>
          </Col>
          <Col sm="8">
            {balanceAndHistoryCheck
              && (
                <h3 style={{ display: 'inline-block', marginLeft: 30 }}>
                  Filtered
                  {' '}
                    {Object.keys(balanceAndHistoryCheck).length}
                  {' '}
                  rooms out of
                  {' '}
                    {balanceAndHistoryCheckCount}
                  {' '}
                  total
                </h3>
              )
            }
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm="12">
            <Row>
              <Col sm="2">
                <Label for="userId">
                  User id
                </Label>
                <Input
                  type="text"
                  name="userId"
                  id="userId"
                  value={userId}
                  onChange={handleChange}
                  onKeyPress={handleKeyPress}
                />
              </Col>
              <Col sm="2">
                <Label for="startDate">
                  From
                </Label>
                <Row>
                  <Col md="12">
                    <DateTimePicker
                      format="DD.MM.YYYY HH:mm"
                      culture="en"
                      onChange={date => changeStartDate(date)}
                      value={startDate}
                      defaultValue={new Date(Date.now() - 24 * 60 * 60 * 1000)}
                    />
                  </Col>
                </Row>
              </Col>
              <Col sm="2">
                <Label for="endDate">
                  To
                </Label>
                <Row>
                  <Col md="12">
                    <DateTimePicker
                      format="DD.MM.YYYY HH:mm"
                      culture="en"
                      onChange={changeEndDate}
                      value={endDate}
                      defaultValue={new Date()}
                    />
                  </Col>
                </Row>
              </Col>
              <Col sm="1" className="d-flex flex-column justify-end">
                {isReset && (
                  <Button className="mb-1" onClick={() => resetFilters()}>
                    Reset
                  </Button>
                )}
                <Button onClick={() => filterFunc()}>
                  Filter
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <table className="w-full fs-4">
          <colgroup>
            <col span="1" className="" />
          </colgroup>
          <thead>
            <tr>
              <th className="text-center">
                Player ID
              </th>
              <th className="text-center">
                Date and Time
              </th>
              <th className="text-center">
                Room ID(for joining a room)
              </th>
              <th className="text-center">
                Old
              </th>
              <th className="text-center">
                New
              </th>
              <th className="text-center">
                View Room
              </th>
              <th className="text-center">
                View Player
              </th>
              
            </tr>
          </thead>
          <tbody>
            {size(balanceAndHistoryCheck) > 0 && Object.keys(balanceAndHistoryCheck)
              .sort((a, b) => balanceAndHistoryCheck[b].time - balanceAndHistoryCheck[a].time)
              .slice(
                currentPage * pageSize,
                (currentPage + 1) * pageSize,
              )
              .map((key, index) => (
                <Fragment key={key}>
                  <tr className={`allUsers-table-row ${index % 2 === 0 ? ('odd') : ('even')}`}>
                    <td className="allUsers-table-col">
                      {balanceAndHistoryCheck[key].userId}
                    </td>
                    <td className="allUsers-table-col">
                      {balanceAndHistoryCheck[key].time && (
                        <DateFormat formatType={FORMAT_DATE_TYPE.fullDateSecond} date={balanceAndHistoryCheck[key].time + offset} />
                      )}
                    </td>
                    <td className="allUsers-table-col">
                      {balanceAndHistoryCheck[key].roomId || (balanceAndHistoryCheck[key].newValue && balanceAndHistoryCheck[key].newValue.roomId) || (balanceAndHistoryCheck[key].oldValue && balanceAndHistoryCheck[key].oldValue.roomId) || ''}
                    </td>

                    <td className="allUsers-table-col">
                      {balanceAndHistoryCheck[key].oldValue ? (`${balanceAndHistoryCheck[key].oldValue.type} from ${balanceAndHistoryCheck[key].oldValue.old} to ${balanceAndHistoryCheck[key].oldValue.new}`) : ''}
                    </td>
                    <td className="allUsers-table-col">
                      {balanceAndHistoryCheck[key].newValue ? (`${balanceAndHistoryCheck[key].newValue.type} from ${balanceAndHistoryCheck[key].newValue.old} to ${balanceAndHistoryCheck[key].newValue.new}`) : ''}
                    </td>
                    <td className="allUsers-table-col">
                      <Button
                        onClick={() => openRoomLogsModal(balanceAndHistoryCheck[key].roomId || (balanceAndHistoryCheck[key].newValue && balanceAndHistoryCheck[key].newValue.roomId) || (balanceAndHistoryCheck[key].oldValue && balanceAndHistoryCheck[key].oldValue.roomId) || '')}
                        disabled={(balanceAndHistoryCheck[key].roomId || (balanceAndHistoryCheck[key].newValue && balanceAndHistoryCheck[key].newValue.roomId) || (balanceAndHistoryCheck[key].oldValue && balanceAndHistoryCheck[key].oldValue.roomId)) ? false : true}
                      >
                        View
                      </Button>
                    </td>
                    <td className="allUsers-table-col">
                      <Button color="primary" onClick={() => openPage(balanceAndHistoryCheck[key].userId)}>
                        View
                      </Button>
                    </td>
                  </tr>
                </Fragment>
              ))}
          </tbody>
        </table>
        <div className="pagination-wrapper">
          <Pagination aria-label="Page navigation example">
            <PaginationItem disabled={currentPage === 0}>
              <PaginationLink style={{ color: '#000' }} onClick={e => handleClick(e, 0)} href="#">
                ‹‹‹
              </PaginationLink>
            </PaginationItem>

            <PaginationItem disabled={currentPage <= 0}>
              <PaginationLink
                style={{ color: '#000' }}
                onClick={e => handleClick(e, currentPage - 1)}
                previous
                href="#"
              />
            </PaginationItem>

            {[...Array(pagesCount)].map((page, i) => {
              if (i > currentPage - 4 && i < currentPage + 4) {
                return (
                  <PaginationItem active={i === currentPage} key={page}>
                    <PaginationLink style={{ color: '#000' }} onClick={e => handleClick(e, i)} href="#">
                      {i + 1}
                    </PaginationLink>
                  </PaginationItem>
                );
              }

              return null;
            })}

            <PaginationItem disabled={currentPage >= pagesCount - 1}>
              <PaginationLink
                style={{ color: '#000' }}
                onClick={e => handleClick(e, currentPage + 1)}
                next
                href="#"
              />
            </PaginationItem>

            <PaginationItem disabled={currentPage >= pagesCount - 1}>
              <PaginationLink style={{ color: '#000' }} onClick={e => handleClick(e, pagesCount - 1)} href="#">
                ›››
              </PaginationLink>
            </PaginationItem>
          </Pagination>
        </div>
      </div>
      <Modal container={`div > div`} isOpen={openModal} toggle={closeModal} style={{ maxWidth: '65%' }}>
        <ModalHeader toggle={closeModal}>
          {selectedroomOptions ? `Room: ${selectedroomOptions.roomId || openModalRoomId}, Game type: ${selectedroomOptions.smallGame ? `${selectedroomOptions.gameType ? selectedroomOptions.gameType : 'P'}M` : `${selectedroomOptions.gameType ? selectedroomOptions.gameType : 'P'}`}, Bet: ${selectedroomOptions.bet}, Speed: ${SPEED_TYPE[selectedroomOptions.speed]}, ${selectedroomOptions.minGames ? `Min Games: ${selectedroomOptions.minGames}` : ''}, ${selectedroomOptions.studentRoom ? '2' : (selectedroomOptions.fourPRoom ? '4' : '3')} Players` : ''}
        </ModalHeader>
        <ModalBody>
          <RoomLogs roomData={selectedRoomData} roomId={openModalRoomId} roomParams={selectedroomOptions} offset={offset} />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={closeModal}>Close</Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default BalanceAndHistoryCheck;
